import { Editor, Extension, findParentNode } from "@tiptap/core";
import { Suggestion } from "@tiptap/suggestion";
import { Plugin, PluginKey } from "prosemirror-state";
import BlockMenuView from "./BlockMenuView";
import { Decoration, DecorationSet } from "prosemirror-view";
import { defaultBlockMenuItems } from "./default-items";

let mView:any,mProps:any;

export type BlockMenuItem =
  | {
    separator: true;
  }
  | {
    separator?: false;
    name: string;
    keywords: string;
    view: (dom: HTMLElement) => void;
    command: (editor: Editor, from?: any, indent?: any) => void;
    disable?: (editor: Editor) => boolean;
    showInTemplate?: true;
  };

export type BlockMenuOptions = {
  pluginKey: string;
  items: BlockMenuItem[];
  dictionary: {
    newLineEmpty: string;
    newLineWithSlash: string;
    queryEmpty: string;
  };
};

/** 输入 / 的起始位置， 用于“输入完成后清除输入的字符” */
let startPos = 0

// 获取模板编辑器的菜单项（过滤掉 showInTemplate: false 的项目）
export const getTemplateBlockMenuItems = (from) => {
  return defaultBlockMenuItems(from).filter((item: any) => {
    if (item.separator) return true;
    return item.showInTemplate !== false;
  });
};

// 用于模板编辑器的 BlockMenu（过滤掉 showInTemplate: false 的项目）
export const getBlockMenuForTemplate = (from) => {
  return Extension.create<BlockMenuOptions>({
    name: "blockMenu",
    addOptions() {
      return {
        pluginKey: "blockMenuTemplate",
        items: getTemplateBlockMenuItems(from),
        dictionary: {
          newLineEmpty: "",
          newLineWithSlash: "",
          queryEmpty: "",
        },
      };
    },
    addProseMirrorPlugins() {
      return [
        Suggestion({
          editor: this.editor,
          pluginKey: new PluginKey(this.options.pluginKey),
          char: "/",
          items: ({ query }) => {

            let items: any = this.options.items.filter(
                (item: any) => item.separator || !item.disable?.(this.editor)
            );
            if (query !== "") {
              items = items.filter((item) => {
                if (item.separator) {
                  return true;
                }
                const n = query.toLowerCase();
                return (
                    item.name.toLowerCase().includes(n) ||
                    item.keywords.toLowerCase().includes(n)
                );
              });
            }
            return items.reduce((acc, item, index) => {
              if ((index === 0 || index === items.length - 1) && item.separator) {
                return acc;
              }
              const prev = items[index - 1];
              const next = items[index + 1];
              if (item.separator) {
                if (prev && prev.separator) {
                  return acc;
                }
                if (next && next.separator) {
                  return acc;
                }
              }
              return [...acc, item];
            }, [] as BlockMenuItem[]);
          },
          command: ({ editor, props }) => {
            const { state, dispatch } = editor.view;
            const $from = state.selection.$from,
                start = $from.start(),
                end = $from.pos;

            const resolvedPos = this.editor.state.doc.resolve(start);
            const currentNode = resolvedPos.node();

            const tr = state.tr.deleteRange(startPos - 1, end);
            dispatch(tr);
            const from = editor.state.selection.from;

            if (end - start > 1) {
              editor.commands.insertContent('<p></p>')
            }
            const item = props as any;
            item.command(editor, from, currentNode?.attrs.indent);
            editor.view.focus();
          },
          render: () => {
            let view: BlockMenuView;
            return {
              onStart: (props) => {
                view = new BlockMenuView({
                  editor: this.editor,
                  dictionary: this.options.dictionary,
                });
                view.update(props);
                startPos = this.editor.view.state.selection.$from.pos
              },
              onUpdate: (props) => {
                view.update(props);
              },
              onKeyDown: (props) => {
                return view.onKeyDown(props);
              },
              onExit: () => {
                view?.destroy();
              },
            };
          },
        }),
        new Plugin({
          key: new PluginKey(`${this.options.pluginKey}Placeholder`),
          props: {
            decorations: (state) => {
              const parent = findParentNode(
                  (node) => node.type.name === "paragraph"
              )(state.selection);
              if (!parent) {
                return;
              }
              const decorations: Decoration[] = [];
              const isEmpty = parent && parent.node.content.size === 0;
              const isSlash = parent && parent.node.textContent === "/";
              const isTopLevel = state.selection.$from.depth === 1;

              if (isTopLevel) {
                if (isEmpty) {
                  decorations.push(
                      Decoration.node(
                          parent.pos,
                          parent.pos + parent.node.nodeSize,
                          {
                            class: "placeholder",
                            "data-empty-text": this.options.dictionary.newLineEmpty,
                          }
                      )
                  );
                }

                if (isSlash) {
                  decorations.push(
                      Decoration.node(
                          parent.pos,
                          parent.pos + parent.node.nodeSize,
                          {
                            class: "placeholder",
                            "data-empty-text": `  ${this.options.dictionary.newLineWithSlash}`,
                          }
                      )
                  );
                }

                return DecorationSet.create(state.doc, decorations);
              }
              return null;
            },
          },
        }),
      ];
    },
  });
}

export const getBlockMenu = (from = '')=>{

  window.refreshBlockMenu = ()=>{
    if (mView){
      //更新items
      mView.update(mProps);
    }
  }

  return Extension.create<BlockMenuOptions>({
    name: "blockMenu",
    addOptions() {
      return {
        pluginKey: "blockMenu",
        items: defaultBlockMenuItems(from),
        dictionary: {
          newLineEmpty: "",
          newLineWithSlash: "",
          queryEmpty: "",
        },
      };
    },
    addProseMirrorPlugins() {
      return [
        Suggestion({
          editor: this.editor,
          pluginKey: new PluginKey(this.options.pluginKey),
          char:  '、',//为了这个字符，复制了下面这个？？？？？、
          items: ({ query }) => {
            let items: any = this.options.items.filter(
                (item: any) => item.separator || !item.disable?.(this.editor)
            );
            if (query !== "") {
              items = items.filter((item) => {
                if (item.separator) {
                  return true;
                }
                const n = query.toLowerCase();
                return (
                    item.name.toLowerCase().includes(n) ||
                    item.keywords.toLowerCase().includes(n)
                );
              });
            }
            return items.reduce((acc, item, index) => {
              if ((index === 0 || index === items.length - 1) && item.separator) {
                return acc;
              }
              const prev = items[index - 1];
              const next = items[index + 1];
              if (item.separator) {
                if (prev && prev.separator) {
                  return acc;
                }
                if (next && next.separator) {
                  return acc;
                }
              }
              return [...acc, item];
            }, [] as BlockMenuItem[]);
          },
          command: ({ editor, props }) => {
            // clear search
            const { state, dispatch } = editor.view;
            const $from = state.selection.$from,
                start = $from.start(),
                end = $from.pos;

            // 清除前获取是否缩进
            const resolvedPos = this.editor.state.doc.resolve(start);
            const currentNode = resolvedPos.node();

            const tr = state.tr.deleteRange(startPos - 1, end);
            dispatch(tr);
            const from=editor.state.selection.from

            if (end - start > 1 && props.name !== 'Inline math' && props.name !== 'Card') {
              editor.commands.insertContent('<p></p>')
            }
            // command
            const item = props as any;
            item.command(editor,from,currentNode?.attrs.indent);
            // focus
            editor.view.focus();
          },
          render: () => {
            let view: BlockMenuView;
            return {
              onStart: (props) => {
                if (props.editor.isFocused){
                  view = new BlockMenuView({
                    editor: this.editor,
                    dictionary: this.options.dictionary,
                  });
                  view.update(props);

                  mView = view;
                  mProps = props;

                  startPos = this.editor.view.state.selection.$from.pos
                }

              },
              onUpdate: (props) => {
                view.update(props);
                mProps = props;
              },
              onKeyDown: (props) => {
                return view.onKeyDown(props);
              },
              onExit: () => {
                view?.destroy();
                // try{
                //   clearInterval(backgroundTask)
                // }catch{}
              },
            };
          },
        }),
        Suggestion({
          editor: this.editor,
          pluginKey: new PluginKey(this.options.pluginKey),
          char:  '/',
          items: ({ query }) => {
            let items: any = this.options.items.filter(
                (item: any) => item.separator || !item.disable?.(this.editor)
            );
            if (query !== "") {
              items = items.filter((item) => {
                if (item.separator) {
                  return true;
                }
                const n = query.toLowerCase();
                return (
                    item.name.toLowerCase().includes(n) ||
                    item.keywords.toLowerCase().includes(n)
                );
              });
            }
            return items.reduce((acc, item, index) => {
              if ((index === 0 || index === items.length - 1) && item.separator) {
                return acc;
              }
              const prev = items[index - 1];
              const next = items[index + 1];
              if (item.separator) {
                if (prev && prev.separator) {
                  return acc;
                }
                if (next && next.separator) {
                  return acc;
                }
              }
              return [...acc, item];
            }, [] as BlockMenuItem[]);
          },
          command: ({ editor, props }) => {
            // clear search
            const { state, dispatch } = editor.view;
            const $from = state.selection.$from,
                start = $from.start(),
                end = $from.pos;

            // 清除前获取是否缩进
            const resolvedPos = this.editor.state.doc.resolve(start);
            const currentNode = resolvedPos.node();

            const tr = state.tr.deleteRange(startPos - 1, end);
            dispatch(tr);
            const from=editor.state.selection.from

            if (end - start > 1 && props.name !== 'Inline math' && props.name !== 'Card') {
              editor.commands.insertContent('<p></p>')
            }
            // command
            const item = props as any;
            item.command(editor,from,currentNode?.attrs.indent);
            // focus
            editor.view.focus();
          },
          render: () => {
            let view: BlockMenuView;
            return {
              onStart: (props) => {
                if (props.editor.isFocused){
                  view = new BlockMenuView({
                    editor: this.editor,
                    dictionary: this.options.dictionary,
                  });
                  view.update(props);
                  startPos = this.editor.view.state.selection.$from.pos
                }

              },
              onUpdate: (props) => {
                view.update(props);
              },
              onKeyDown: (props) => {
                return view.onKeyDown(props);
              },
              onExit: () => {
                view?.destroy();
                // try{
                //   clearInterval(backgroundTask)
                // }catch{}
              },
            };
          },
        }),
        new Plugin({
          key: new PluginKey(`${this.options.pluginKey}Placeholder`),
          props: {
            decorations: (state) => {
              const parent = findParentNode(
                  (node) => node.type.name === "paragraph"
              )(state.selection);
              if (!parent) {
                return;
              }
              const decorations: Decoration[] = [];
              const isEmpty = parent && parent.node.content.size === 0;
              const isSlash = parent && parent.node.textContent === "/";
              const isTopLevel = state.selection.$from.depth === 1;

              if (isTopLevel) {
                if (isEmpty) {
                  decorations.push(
                      Decoration.node(
                          parent.pos,
                          parent.pos + parent.node.nodeSize,
                          {
                            class: "placeholder",
                            "data-empty-text": this.options.dictionary.newLineEmpty,
                          }
                      )
                  );
                }

                if (isSlash) {
                  decorations.push(
                      Decoration.node(
                          parent.pos,
                          parent.pos + parent.node.nodeSize,
                          {
                            class: "placeholder",
                            "data-empty-text": `  ${this.options.dictionary.newLineWithSlash}`,
                          }
                      )
                  );
                }

                return DecorationSet.create(state.doc, decorations);
              }
              return null;
            },
          },
        }),
      ];
    },

    // addKeyboardShortcuts() {
    //   return {
    //     Tab: () => this.editor.chain().command(({ tr }) => {
    //       // 在事务中执行以下代码
    //       tr.insertText('    ')
    //       return true
    //     })
    //     .run()
    //   }
    // }
  });
}

export const BlockMenu = Extension.create<BlockMenuOptions>({
  name: "blockMenu",
  addOptions() {
    return {
      pluginKey: "blockMenu",
      items: defaultBlockMenuItems,
      dictionary: {
        newLineEmpty: "",
        newLineWithSlash: "",
        queryEmpty: "",
      },
    };
  },
  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        pluginKey: new PluginKey(this.options.pluginKey),
        char: "/",
        items: ({ query }) => {
          let items: any = this.options.items.filter(
              (item: any) => item.separator || !item.disable?.(this.editor)
          );
          if (query !== "") {
            items = items.filter((item) => {
              if (item.separator) {
                return true;
              }
              const n = query.toLowerCase();
              return (
                  item.name.toLowerCase().includes(n) ||
                  item.keywords.toLowerCase().includes(n)
              );
            });
          }
          return items.reduce((acc, item, index) => {
            if ((index === 0 || index === items.length - 1) && item.separator) {
              return acc;
            }
            const prev = items[index - 1];
            const next = items[index + 1];
            if (item.separator) {
              if (prev && prev.separator) {
                return acc;
              }
              if (next && next.separator) {
                return acc;
              }
            }
            return [...acc, item];
          }, [] as BlockMenuItem[]);
        },
        command: ({ editor, props }) => {
          // clear search
          const { state, dispatch } = editor.view;
          const $from = state.selection.$from,
              start = $from.start(),
              end = $from.pos;
          // console.log('end: ', end);
          // console.log('$from.start(): ', $from.start());
          // const tr = state.tr.deleteRange($from.start(), $from.pos);
          // const tr = state.tr.deleteRange(end - 1, end);
          const tr = state.tr.deleteRange(startPos - 1, end);
          dispatch(tr);
          if (end - start > 1 && props.name !== 'Inline math' && props.name !== 'Card') {
            editor.commands.insertContent('<p></p>')
          }
          // command
          const item = props as any;
          item.command(editor);
          // focus
          editor.view.focus();
        },
        render: () => {
          let view: BlockMenuView;
          return {
            onStart: (props) => {
              view = new BlockMenuView({
                editor: this.editor,
                dictionary: this.options.dictionary,
              });
              view.update(props);
              startPos = this.editor.view.state.selection.$from.pos
              // try{
              //   clearInterval(backgroundTask)
              // }catch{}
              // backgroundTask = setInterval(() => {
              //   console.log('abcdddd-----');
              //   window.GEditorupdateBackground?.()
              // }, 300)
            },
            onUpdate: (props) => {
              view.update(props);
            },
            onKeyDown: (props) => {
              return view.onKeyDown(props);
            },
            onExit: () => {
              view.destroy();
              // try{
              //   clearInterval(backgroundTask)
              // }catch{}
            },
          };
        },
      }),
      new Plugin({
        key: new PluginKey(`${this.options.pluginKey}Placeholder`),
        props: {
          decorations: (state) => {
            const parent = findParentNode(
                (node) => node.type.name === "paragraph"
            )(state.selection);
            if (!parent) {
              return;
            }
            const decorations: Decoration[] = [];
            const isEmpty = parent && parent.node.content.size === 0;
            const isSlash = parent && parent.node.textContent === "/";
            const isTopLevel = state.selection.$from.depth === 1;

            if (isTopLevel) {
              if (isEmpty) {
                decorations.push(
                    Decoration.node(
                        parent.pos,
                        parent.pos + parent.node.nodeSize,
                        {
                          class: "placeholder",
                          "data-empty-text": this.options.dictionary.newLineEmpty,
                        }
                    )
                );
              }

              if (isSlash) {
                decorations.push(
                    Decoration.node(
                        parent.pos,
                        parent.pos + parent.node.nodeSize,
                        {
                          class: "placeholder",
                          "data-empty-text": `  ${this.options.dictionary.newLineWithSlash}`,
                        }
                    )
                );
              }

              return DecorationSet.create(state.doc, decorations);
            }
            return null;
          },
        },
      }),
    ];
  },
});
